export enum ServicesEnum {
    IME = 1,
    TCM = 2, // Telephonic Case Management
    PT = 3,
    Diagnostic = 4,
    UR = 5,
    TT = 6,
    DME = 7,
    SIU = 8,
    FCM = 9, // Field Case Management
    RTW = 10, // Return To Work
}
